import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpInterceptor,
  HttpRequest,
  HttpHandler
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../../pages/auth/services/auth.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isRefreshing = false; // Track refresh token attempts
  private refreshTokenInProgress: Observable<any> | null = null;

  constructor(
      private _authService: AuthService,
      private _router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const authTokenStr = localStorage.getItem('a_ad_token');
    const authToken = authTokenStr ? JSON.parse(authTokenStr) : null;

    req = req.clone({
      setHeaders: authToken
          ? { Authorization: `Bearer ${authToken}`, Admin: 'false' }
          : { Admin: 'false' },
      url: `${environment.base_url}${req.url}`
    });

    return next.handle(req).pipe(
     
        catchError((error: HttpErrorResponse) => {
         // console.log(req.url, 'this is the req url')
          if(error.status === 401 && req.url.endsWith('api/token/')){
          //  console.log('Here api token called')
            return throwError(error);
          }
          if (error.status === 401 && !req.url.endsWith('api/token/refresh/')) {
            return this.handle401Error(req, next);
          }
          return throwError(error);
        })
    );
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const refreshTokenStr = localStorage.getItem('r_ad_token');
    const refreshToken = refreshTokenStr ? JSON.parse(refreshTokenStr) : null;

    if (this.isRefreshing || !refreshToken) {
     // console.log('I am called')
      this.logout();
      return throwError('Session expired. Redirecting to login.');
    } 
      

    this.isRefreshing = true;
    this.refreshTokenInProgress = this._authService.refreshToken(refreshToken).pipe(
        switchMap((response: any) => {
          localStorage.setItem('a_ad_token', JSON.stringify(response.access));
          localStorage.setItem('r_ad_token', JSON.stringify(response.refresh));
          this.isRefreshing = false;
          this.refreshTokenInProgress = null;

          const authReq = req.clone({
            setHeaders: { Authorization: `Bearer ${response.access}`, Admin: 'false' },
          });
          return next.handle(authReq);
        }),
        catchError((refreshError: HttpErrorResponse) => {
          this.logout();
          return throwError(refreshError);
        })
    );

    return this.refreshTokenInProgress;
  }

  private logout() {
    localStorage.clear();
    this.isRefreshing = false;
    this.refreshTokenInProgress = null;
    this._router.navigate(['/login']);
  }
}
